import {
    IProcess,
    IProcessPayloadUserInput,
    IRunningProcess,
} from './Interfaces';

export interface IProcessState {
    processes: Array<IProcess>;
    selectedProcess: IProcess | null;
    proccessPayloadInputs: Array<IProcessPayloadUserInput>;
    runningProcesses: Array<IRunningProcess>;
    hasProgressStateLoaded: boolean;
    OLDpayloadData: object;
}

export const initialProcessState: IProcessState = {
    processes: [],
    selectedProcess: null,
    proccessPayloadInputs: [],
    hasProgressStateLoaded: false,
    runningProcesses: [],
    OLDpayloadData: null,
};
